// Counted on the serialized HTML, so markup is included in the limit.
export const TASK_DESCRIPTION_MAX_LENGTH = 64000

export const getDescriptionLength = (description?: string | null) => (
    typeof description === 'string' ? description.length : 0
)

export const isDescriptionTooLong = (description?: string | null) => (
    getDescriptionLength(description) > TASK_DESCRIPTION_MAX_LENGTH
)

export const getDescriptionLengthError = (maxLength: number) => (
    `Описание не должно превышать ${maxLength} символов.`
)

export const TASK_DESCRIPTION_LENGTH_ERROR = getDescriptionLengthError(TASK_DESCRIPTION_MAX_LENGTH)
export const TASK_DESCRIPTION_FORBIDDEN_CONTENT_ERROR = 'Описание содержит контент, запрещённый правилами системы. Отредактируйте текст и попробуйте ещё раз.'

interface ApiValidationError {
    type?: string
    loc?: unknown[]
    ctx?: { max_length?: unknown }
}

const getDescriptionValidationErrors = (responseData: unknown): ApiValidationError[] => {
    if (!responseData || typeof responseData !== 'object') {
        return []
    }

    const detail = (responseData as { detail?: unknown }).detail

    if (!Array.isArray(detail)) {
        return []
    }

    return detail.filter((error): error is ApiValidationError => (
        Boolean(error)
        && typeof error === 'object'
        && Array.isArray((error as ApiValidationError).loc)
        && (error as ApiValidationError).loc?.includes('description')
    ))
}

const hasDescriptionErrorType = (responseData: unknown, errorType: string) => {
    const validationErrors = getDescriptionValidationErrors(responseData)

    if (validationErrors.length > 0) {
        return validationErrors.some(({ type }) => type === errorType)
    }

    if (typeof responseData !== 'string') {
        return false
    }

    return responseData.toLowerCase().includes(errorType)
        && /description/i.test(responseData)
}

export const isDescriptionLengthApiError = (responseData: unknown) => (
    hasDescriptionErrorType(responseData, 'string_too_long')
)

export const isDescriptionForbiddenContentApiError = (responseData: unknown) => (
    hasDescriptionErrorType(responseData, 'value_error')
)

export const getDescriptionApiErrorMessage = (responseData: unknown) => {
    const validationErrors = getDescriptionValidationErrors(responseData)
    const errorTypes = new Set(validationErrors.map(({ type }) => type))

    if (errorTypes.has('string_too_long') || (
        validationErrors.length === 0
        && isDescriptionLengthApiError(responseData)
    )) {
        // The backend limit may differ from ours, so report the one it enforced.
        const serverMaxLength = validationErrors
            .find(({ type }) => type === 'string_too_long')
            ?.ctx?.max_length

        return typeof serverMaxLength === 'number'
            ? getDescriptionLengthError(serverMaxLength)
            : TASK_DESCRIPTION_LENGTH_ERROR
    }

    if (errorTypes.has('value_error') || (
        validationErrors.length === 0
        && isDescriptionForbiddenContentApiError(responseData)
    )) {
        return TASK_DESCRIPTION_FORBIDDEN_CONTENT_ERROR
    }

    return null
}
